import cn from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { MANAGER_COCKPIT_TOUR_TARGETS as TOUR_TARGETS } from 'partner360/configs/widgetTour/managerCockpitTourTargets'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../configs/translations'

import styles from './ManagerPlanningCockpitSwitcher.module.scss'

export type TManagerPlanningCockpitSection =
  | 'cockpit'
  | 'topPartners'
  | 'myPartners'
  | 'businessPriorities'
  | 'marketYoyTargets'
  | 'strategicInitiatives'
  | 'coverageReport'

interface IManagerPlanningCockpitSwitcherProps {
  selectedSection: TManagerPlanningCockpitSection
  sections: TManagerPlanningCockpitSection[]
  myPartnersCount: number
  onChange: (section: TManagerPlanningCockpitSection) => void
}

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.tabs

export const ManagerPlanningCockpitSwitcher = ({
  selectedSection,
  sections,
  myPartnersCount,
  onChange,
}: IManagerPlanningCockpitSwitcherProps) => {
  return (
    <div className={styles.root} data-tour-id={TOUR_TARGETS.sectionRail}>
      {sections.map((id) => (
        <button
          key={id}
          type="button"
          aria-pressed={selectedSection === id}
          className={cn(styles.title, { [styles.selected]: selectedSection === id })}
          onClick={() => onChange(id)}
        >
          <Translation
            text={KEYS[id]}
            replaceParams={
              id === 'myPartners'
                ? [{ key: '{count}', value: myPartnersCount.toString() }]
                : undefined
            }
          />
        </button>
      ))}
    </div>
  )
}
